<template>
    <TsLoadingCircularSpinner />
</template>

<script setup>

const localePath = useLocalePath();
const TsLoadingCircularSpinner = defineAsyncComponent(
  () => import('~/components/organisms/TsLoadingCircularSpinner.vue')
);

onMounted(() => {
  navigateTo(localePath('/checkout'))
})

definePageMeta({
  layout: "checkout",
  middleware: ["checkout-protect"],
});

</script>